import React, { useState, useEffect } from 'react';
import StatCard from '../components/statCard';
import BookingsChart from '../components/bookingsChart';
import UpcomingEvents from '../components/Upcomingevents';
import RecentActivity from '../components/Recentactivity';
import QuickActions from '../components/Quickactions';
import './home.css';
import PageLayout from '../components/pagelayout';

const BookingIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="4" width="18" height="17" rx="2" stroke="white" strokeWidth="1.8"/>
    <path d="M16 2v4M8 2v4M3 10h18" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const VisitorIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
    <circle cx="9" cy="7" r="4" stroke="white" strokeWidth="1.8"/>
    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const SavedIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ExhibitorIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M3 9l9-6 9 6v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const VolunteerIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
    <circle cx="9" cy="7" r="4" stroke="white" strokeWidth="1.8"/>
    <path d="M19 8l2 2-4 4" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const TrendIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M23 6l-9.5 9.5-5-5L1 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17 6h6v6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const stats = [
  { label: 'Total Bookings', value: '12,458', change: '+12.5%', icon: <BookingIcon /> },
  { label: "Today's Visitors", value: '2,847', change: '+8.2%', icon: <VisitorIcon /> },
  { label: 'Saved Events', value: '5,234', change: '+23.1%', icon: <SavedIcon /> },
  { label: 'Exhibitors', value: '428', change: '+5.3%', icon: <ExhibitorIcon /> },
  { label: 'Volunteer Apps', value: '186', change: '+15.7%', icon: <VolunteerIcon /> },
  { label: 'Trending Booths', value: '24', change: '+9.4%', icon: <TrendIcon /> },
];

function useCountdown(targetDays = 12, targetHours = 8, targetMins = 34) {
  const [time, setTime] = useState({ days: targetDays, hours: targetHours, mins: targetMins, secs: 0 });

  useEffect(() => {
    const total = ((targetDays * 24 + targetHours) * 60 + targetMins) * 60;
    let remaining = total;

    const interval = setInterval(() => {
      remaining--;
      if (remaining <= 0) { clearInterval(interval); return; }
      const d = Math.floor(remaining / 86400);
      const h = Math.floor((remaining % 86400) / 3600);
      const m = Math.floor((remaining % 3600) / 60);
      const s = remaining % 60;
      setTime({ days: d, hours: h, mins: m, secs: s });
    }, 1000);

    return () => clearInterval(interval);
  },);

  return time;
}

function pad(n) { return String(n).padStart(2, '0'); }

export default function Home() {
  const countdown = useCountdown(12, 8, 34);

  return (
    <PageLayout activePage="dashboard">
      <div className="home-hero">
        <div className="home-hero-content">
          <p className="home-hero-subtitle">Cairo International Book Fair 2026</p>
          <h1 className="home-hero-title">Welcome to Admin Dashboard</h1>
          <div className="home-countdown">
            <div className="countdown-label">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/>
                <path d="M12 7v5l3 3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
              </svg>
              Countdown to Opening
            </div>
            <div className="countdown-timer">
              <div className="countdown-unit">
                <span className="countdown-num">{pad(countdown.days)}</span>
                <span className="countdown-unit-label">days</span>
              </div>
              <span className="countdown-sep">:</span>
              <div className="countdown-unit">
                <span className="countdown-num">{pad(countdown.hours)}</span>
                <span className="countdown-unit-label">hours</span>
              </div>
              <span className="countdown-sep">:</span>
              <div className="countdown-unit">
                <span className="countdown-num">{pad(countdown.mins)}</span>
                <span className="countdown-unit-label">min</span>
              </div>
              <span className="countdown-sep">:</span>
              <div className="countdown-unit">
                <span className="countdown-num">{pad(countdown.secs)}</span>
                <span className="countdown-unit-label">sec</span>
              </div>
            </div>
          </div>
        </div>
        <div className="home-hero-deco" aria-hidden="true">
          <div className="hero-circle hero-circle-1" />
          <div className="hero-circle hero-circle-2" />
          <div className="hero-circle hero-circle-3" />
        </div>
      </div>

      <div className="home-stats-grid">
        {stats.map((stat) => (
          <StatCard
            key={stat.label}
            label={stat.label}
            value={stat.value}
            change={stat.change}
            icon={stat.icon}
          />
        ))}
      </div>

      <div className="home-charts-row">
        <div className="home-chart-main">
          <BookingsChart />
        </div>
        <div className="home-chart-side">
          <UpcomingEvents />
        </div>
      </div>

      <div className="home-bottom-row">
        <div className="home-bottom-activity">
          <RecentActivity />
        </div>
        <div className="home-bottom-actions">
          <QuickActions />
        </div>
      </div>
    </PageLayout>
  );
}